<template>
  <section class="builder-formula">
    <FormulaHeader :formula="formula" />

    <FormulaEditionBox
      v-if="inEditionMode"
      :formula="formula"
    />

    <FormulaSettings :formula="formula" />
    <div
      class="formula-content scrollbar is-scrollable"
      :class="[{ 'in-edit-mode': inEditionMode }, { 'in-disabled-cross-device': !xdevice }]"
    >
      <FormulaBox
        v-for="(box, index) in formula.boxes"
        :key="index"
        :box="box"
        :index="index"
        :volume-index="volumeIndexes[index]"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FormulaBox from './FormulaBox.vue'
import FormulaEditionBox from './FormulaEditionBox.vue'
import FormulaHeader from './FormulaHeader.vue'
import FormulaSettings from './FormulaSettings.vue'

export default {
    name: 'Formula',

    props: {
        formula: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters('builder', ['inEditionMode']),
        ...mapState('ui/settings', {
            xdevice: state => state.general.xdevice,
        }),

        volumeIndexes() {
            let counter = 0
            return this.formula.boxes.map(box => (box.isEmpty || box.disabled ? undefined : counter++))
        }
    },

    components: {
        FormulaBox,
        FormulaEditionBox,
        FormulaHeader,
        FormulaSettings
    }
}
</script>
